import { useState } from 'react';

import { Box, Typography, Stack } from '@mui/material';

import { Action, ActionStatus  } from 'models';
import SortableTable from '../issueDetails/issueTable/SortableTable'
import Icon from 'components/icons/Icon';
import { defaultAppTheme } from 'styles/mui_app_theme/defaultAppTheme';


import ButtonToOpenDialog from 'app/widgets/dialogs/ButtonToOpenDialog';
import ActionsCollaborationPanel from './Collaborators/actionCollaboration/ActionsCollaborationPanel';
import { fullDateAndTimeFromISO } from 'utils/datetime_utils_old';
import { useNavigate } from 'react-router';


const ActionsTable =
({
	actions,
	title,
}: {
	actions: Action[],
	title?: string,
}
) =>
{
	const navigate = useNavigate();
	
	const [ closeDialog, setCloseDialog ] = useState<boolean>(false);
	
	return(
		<Box>
			<Typography
				variant='h6'
			>
				{title}
			</Typography>
			
			<SortableTable
					options={actions}
					onSelect={(selectedOption: Action) => {
						if(selectedOption?.issue_id !== undefined)
						{
							navigate(`/issues/${selectedOption.issue_id}`)
						}
						else
						{
							navigate(`/requisitions/${selectedOption?.requisition_id}`)
						}
					}}
					rows={[
						{
							title: 'Action #',
							getCell(action) {
								return (
									<Box sx={{ marginInline: '0.5rem' }}>
										{action?.action_num}
									</Box>
								)
							}
						},
						{
							title: 'Status',
							getCell(action) {
								return (
									<Stack
										direction='row'
										justifyContent='flex-start'
										alignItems='center'
									>
										<Icon
											of={
												(action?.status === ActionStatus.OPEN) ?
												'open_action' : 'closed_action'
											}
											size='20px'
											color={
												(action?.status === ActionStatus.OPEN) ?
												defaultAppTheme.palette.secondary.main :
												(action?.status === ActionStatus.IN_PROGRESS) ?
												defaultAppTheme.palette.primary.main :
												(action?.status === ActionStatus.RESOLVED) ?
												defaultAppTheme.palette.success.main :
												defaultAppTheme.palette.grey['800']
											}
										/>
										
										<Typography
											variant='caption'
											color={
												(action?.status === ActionStatus.OPEN) ?
												defaultAppTheme.palette.secondary.main :
												(action?.status === ActionStatus.IN_PROGRESS) ?
												defaultAppTheme.palette.primary.main :
												(action?.status === ActionStatus.RESOLVED) ?
												defaultAppTheme.palette.success.main :
												defaultAppTheme.palette.grey['800']
											}
											sx={{
												paddingLeft: '5px',
											}}
										>
											{ action.status }
										</Typography>
									</Stack>
								)
							}
						},
						{
							title: 'Inquiry',
							getCell(action) {
								return (
									<Typography variant='body1'>
										{ action.inquiry }
									</Typography>
								)
							}
						},
						{
							title: 'Date Issued',
							getCell(action) {
								return (
									<Typography>
										{ fullDateAndTimeFromISO(action.created_at) }
									</Typography>
								)
							}
						},
						{
							title: 'Edit Action',
							getCell(action) {
								return (
									<ButtonToOpenDialog
										button_variant='text'
										dialog_title={`Action #${action.action_num}`}
										dialog_dismiss_text='Exit'
										dialog_content={
											<ActionsCollaborationPanel
												action={action}
												closeDialog={closeDialog}
												setCloseDialog={setCloseDialog}
											/>
										}
										closeDialog={closeDialog}
										buttonIcon={
											<Icon
												of='edit'
												size='24px'
												color={defaultAppTheme.palette.primary.main}
											/>
										}
										button_type='icon_button'
									/>
								)
							}
						},
					]}
				/>

		</Box>
	)
};


export default ActionsTable;